
import { useState } from 'react';

export type ObjectivityModelType = 'model1' | 'model2' | 'model3';

export const useObjectivityModel = (initialModel: ObjectivityModelType = 'model3') => {
  const [activeModel, setActiveModel] = useState<ObjectivityModelType>(initialModel);

  const toggleModel = () => {
    setActiveModel(prev => {
      if (prev === 'model1') return 'model2';
      if (prev === 'model2') return 'model3';
      return 'model1';
    });
  };

  const getModelLabel = (model: ObjectivityModelType) => {
    switch (model) {
      case 'model1': return 'Calculated Model';
      case 'model2': return 'Direct Measurement';
      case 'model3': return 'Reverse Scoring';
      default: return 'Unknown Model';
    }
  };

  const getModelDescription = (model: ObjectivityModelType) => {
    switch (model) {
      case 'model1': return 'Based on Order minus Connection';
      case 'model2': return 'Based on selected objectivity words';
      case 'model3': return 'Start at 100%, deduct for subjective words';
      default: return 'Unknown model description';
    }
  };

  return {
    activeModel,
    setActiveModel,
    toggleModel,
    getModelLabel,
    getModelDescription
  };
};
